import moment from 'moment'
import _ from 'lodash'
import config from "./actions/config"

export default {
    safeParse: function(str) {
        let result = {}
        switch (typeof str) {
            case 'string':
                try {
                    result = JSON.parse(str)
                } catch(e) {
                    console.error("Couldn't parse JSON", e, str)
                }
                break
            case 'object':
                result = str
                break
            default:
                console.error('Vous essayez de parser un objet de type ' + typeof str +'.')
                break
        }

        return result
    },
    printPrice : function(price) {
        return _.round(parseFloat(price), 2).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1 ')
    },
    addBusinessDays: function(date, daysToAdd) {
        let cnt = 0;
        let tmpDate = moment(date);
        while (cnt < daysToAdd) {
            tmpDate = tmpDate.add('days', 1);
            if (tmpDate.weekday() !== 5 && tmpDate.weekday() !== 6) {
                cnt = cnt + 1;
            }
        }
     
        return tmpDate;
    },
    checkAddress: function(address) {
        if (!address) return false

        const postalObject = _.find(address.address_components, c => {
            return _.find(c.types, type => type === 'postal_code')
        }) || {}
        const pc = (postalObject.long_name || '').slice(0, 2)

        return pc === '75' || pc === '92' || pc === '93' || pc === '94'
    },
    getImgPath: function(img) {
        return config.appUrl + img
    }
}


// WEBPACK FOOTER //
// ./src/utils.js